import {attributesToProps, domToReact, Element} from 'html-react-parser'

import {TextLink} from '../TextLink'
import {Dfn, H3, Ol, P, Span, Ul} from './Nodes'

import type {DOMNode} from 'html-react-parser'
import type {ReactElement} from 'react'

export const allowedTags = [
  'h1', 'h2', 'h3', 'h4', 'h5',
  'p', 'i', 'em', 'b', 's', 'ul', 'ol', 'li',
  'strong', 'a', 'br', 'small', 'span',
  'sup', 'sub', 'del', 'dfn',
] as const
export type AllowedTags = typeof allowedTags[number]

export const options = {
  replace: (domNode: DOMNode) => {
    if (domNode instanceof Element) {
      const children = domToReact(domNode.children, options)
      const props = attributesToProps(domNode.attribs)

      const elements: Record<AllowedTags, ReactElement> = {
        h1: <H3 {...props}>{children}</H3>,
        h2: <H3 {...props}>{children}</H3>,
        h3: <H3 {...props}>{children}</H3>,
        h4: <H3 {...props}>{children}</H3>,
        h5: <P>{children}</P>,
        p: <P>{children}</P>,
        i: (<i>{children}</i>),
        em: (<i>{children}</i>),
        b: (<b>{children}</b>),
        strong: (<b>{children}</b>),
        a: <TextLink {...props}>{children}</TextLink>,
        br: <br />,
        ul: <Ul {...props}>{children}</Ul>,
        ol: <Ol {...props}>{children}</Ol>,
        li: <li>{children}</li>,
        small: <small>{children}</small>,
        del: <del>{children}</del>,
        s: <del>{children}</del>,
        sup: <sup>{children}</sup>,
        sub: <sub>{children}</sub>,
        // <dfn> is currently only used by the backend in the opener page for:
        //  - EnVKV values
        //  - general disclaimer text
        // This tag should not be creatable by customers in the editor
        // Since the tag is only used for disclaimers (aka small-print) we replace the <dfn> tag
        //  with the <small> tag for semantic reasons.
        dfn: <Dfn>{children}</Dfn>,
        span: <Span {...props}>{children}</Span>,
      }

      return elements[domNode.name as AllowedTags]
    }
  },
}
